import React from 'react';
import './CardSection.scss';

const CardSection = ({tags, descText, buttonText, flex}) => {
  return (
    <div className="app-container" style={{display: "flex", height: "auto"}}>
      <div className="tags" style={{display: 'flex', flexDirection: 'row', justifyContent: flex}}>
        {tags.map((tag, index) => (
          <span className="tag" style={{display: "flex", width: "100%", padding: "10px"}} key={index}>{tag}</span>
        ))}
      </div>
      <div className="description-container">
        <p>{descText}</p>
      </div>
      <div className="button-container">
        <a href="#contact">
          <button className="develop-button">{buttonText}</button>
        </a>
      </div>
    </div>
  );
}

export default CardSection;
